import { ServiceUtils } from '../src/ServiceUtils';
export var ServicePlanType;
(function (ServicePlanType) {
    ServicePlanType["SYSTEM"] = "SYSTEM";
    ServicePlanType["ANONYMOUS"] = "ANONYMOUS";
    ServicePlanType["BASIC"] = "BASIC";
    ServicePlanType["ADVANCED"] = "ADVANCED";
    ServicePlanType["PROFESSIONAL"] = "PROFESSIONAL";
})(ServicePlanType || (ServicePlanType = {}));
export class SessionService {
    constructor(callContext, implName = 'SessionService') {
        this.axios = ServiceUtils.createSpringAxiosInstance(callContext, implName);
    }
    preloadSessionData(doSignOut) {
        const call = {
            methodName: 'preloadSessionData',
            args: { doSignOut },
        };
        return this.axios.post('', call);
    }
    touchSession() {
        const call = {
            methodName: 'touchSession',
            args: {},
        };
        return this.axios.post('', call);
    }
    receiveMessages() {
        const call = {
            methodName: 'receiveMessages',
            args: {},
        };
        return this.axios.post('', call);
    }
}
//# sourceMappingURL=SessionService.js.map